import {useContext} from 'react';
import {useExperiment as useFlipperExperiment} from '@tkww/reg-flipper-sdk';
import {EXPERIMENT_CONFIGS} from '../constants';
import MemberContext from '../contexts/MemberContext';

/**
 * Reusable hook for configuring an experiment. Requires the `name` in order to look up the EXPERIMENT_CONFIGS related
 * including the variant ids and experiment ID for the environment. By default, the bucketId and isEnabled is based on whether a member is loaded in the MemberContext
 * If new criteria are given within experimentOptions, they will override these defaults
 * @param {Object} experimentOptions - options that can be passed to the flipper SDK found here: https://github.com/tkww/reg-flipper-sdk?tab=readme-ov-file#hook-api
 * @returns {{ isLoading: boolean, isInControl: boolean}}
 */
const useExperiment = (experimentOptions = {name: ''}) => {
  const {member, isFetching: isFetchingMember} = useContext(MemberContext);
  const {experimentId, variants} = EXPERIMENT_CONFIGS[experimentOptions.name][
    process.env.ENV
  ];

  const {
    isEnabled = true,
    name,
    ...sanitizedExperimentOptions
  } = experimentOptions;

  const {
    isActive,
    isLoading: isDeterminingAssignment,
    variant,
  } = useFlipperExperiment({
    experimentId,
    bucketingId: member?.id,
    isEnabled: !!member?.id && isEnabled,
    ...sanitizedExperimentOptions,
  });

  const isLoading = isDeterminingAssignment || isFetchingMember || false;

  return {
    isInControl: !isActive || !variant || variants.control.id === variant,
    isLoading,
    variant,
  };
};

export default useExperiment;
